var _style, _path, _circle, _path2, _path3, _path4, _g, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcedures(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "procedures_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 148 148",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".procedures_svg__st0{fill:none;stroke:var(--color-text);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "procedures_svg__st0",
    d: "M55.8 125.5V98.2M92.2 98.2v27.3M17.9 98.2h112.3c4.2 0 7.6-3.4 7.6-7.6 0-4.2-3.4-7.6-7.6-7.6H17.9c-4.2 0-7.6 3.4-7.6 7.6 0 4.2 3.4 7.6 7.6 7.6zM46.9 140.5c0 3.5-2.8 6.4-6.4 6.4-3.6 0-6.4-2.8-6.4-6.4s2.8-6.4 6.4-6.4c3.6 0 6.4 2.9 6.4 6.4z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "procedures_svg__st0",
    cx: 107.5,
    cy: 140.5,
    r: 6.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "procedures_svg__st0",
    d: "M101.1 140.5H46.9M40.5 134.2v-3.4c0-2.9 2.4-5.3 5.3-5.3h56.4c2.9 0 5.3 2.4 5.3 5.3v3.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "procedures_svg__XMLID_30_",
    className: "procedures_svg__st0",
    d: "M26.2 55c-6.1 1.1-10.1 7-9 13.1s7 10.1 13.1 9 10.1-7 9-13.1c-1.2-6.1-7-10.1-13.1-9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "procedures_svg__st0",
    d: "M129 83V65c0-5.5-4.5-10-12.4-4.2H89c-3.2 0-6.3-1-8.8-2.9-2.6-1.9-5.7-2.9-8.8-2.9H56.2c-4.5 0-10.6 3.3-10.6 10 0 0 1.6 8.4-4.6 12.4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "procedures_svg__st0",
    d: "M82.7 29.4l3.8 3.4c3.4 3 5.3 7.3 5.3 11.8v16.2M63.5 29.4l-3.7 3.4c-3.2 3-5.1 7.2-5.1 11.6V55M83.3 17.3c0 5.9-4.8 10.7-10.7 10.7C66.7 28 62 23.2 62 17.3M83.1 11.6v-7c0-1.9-1.5-3.5-3.5-3.5h-14c-1.9 0-3.5 1.5-3.5 3.5v7h21"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.7 65.3l-2.1 1.5c-30.6 0-34.8 1.2-42-4.1-3-2.2-4.4-1.7-20.4-1.7-.9 0-4.3.7-4.6 3.6.4 2.4.4 5.6-.6 8.9h72v-6.9c0-1.2-1.3-1.9-2.3-1.3z",
    fill: "var(--color-icon-primary)"
  })));
}
export default SvgProcedures;